<template>
    <div>
        <div class="form-group pb-1">
            <div class="checkbox-container mb-4">
                <input v-if="esBenidorm" type="checkbox" name="privacidad" id="privacidad" class="required" :checked="true" disabled/>
                <input v-else type="checkbox" name="privacidad" id="privacidad" v-model="datos.privacidad" class="required" checked disabled/>
                <label :for="'privacidad'">
                    <span>{{ $t('formularios.he_leido') }}&nbsp;</span>

                    <router-link :to="{ name: 'legal' }" target="_blank">
                        <span>{{ $t('formularios.terminos_condiciones') }}</span>
                    </router-link>

                    y la

                    <router-link :to="{ name: 'privacidad' }" target="_blank">
                        <span>{{ $t('formularios.politica_privacidad') }}</span>
                    </router-link>
                </label>
            </div>
        </div>

        <div class="form-group pb-1">
            <div class="checkbox-container mb-4">
                <input v-if="esBenidorm" type="checkbox" name="condiciones" id="condiciones" class="required" :checked="true" disabled/>
                <input v-else type="checkbox" name="condiciones" id="condiciones" v-model="datos.condiciones" class="required" checked disabled/>
                <label for="condiciones">{{ $t('formularios.acepto') }} <router-link :to="{ name: 'condiciones_generales'}" target="_blank">
                    <span>{{ $t('formularios.condiciones') }}</span>
                </router-link> </label>
            </div>
        </div>

        <div class="form-group pb-1">
            <div class="checkbox-container mb-4">
                <input type="checkbox" name="comunicaciones" id="comunicaciones" v-model="datos.comunicaciones"/>
                <label :for="'comunicaciones'">
                    {{ $t(teatro.hash === '7IzXuJcTytAub9imoikD' ? 'formularios.acepto_comunicaciones_malecon' : 'formularios.acepto_comunicaciones', { teatro: teatro.nombre }) }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    import { TEATRO_HASH_CF_BENIDORM } from '@/constants/teatros';
    export default {
        props:['datos'],
        computed: {
            // Benidorm muestra las casillas siempre marcadas, sin enlazarlas al modelo.
            esBenidorm() {
                return this.$store.getters.getConfig?.hash_teatro === TEATRO_HASH_CF_BENIDORM;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
        }
    }
</script>